module.exports = __webpack_public_path__ + "static/media/jcb.cf38567c.svg";